import {
  Package, CheckCircle2, Truck, MapPin, MessageCircle, AlertTriangle, Banknote, Wallet, Bell,
  Timer, XCircle, Sparkles, CreditCard, Route,
} from "lucide-react";

const ICONS = {
  new_request: Package, new_offer: Sparkles, accepted: CheckCircle2, offer_accepted: CheckCircle2,
  awaiting_payment: CreditCard, picked_up: Truck, progress: MapPin, chat: MessageCircle,
  dispute: AlertTriangle, refund: Banknote, payout: Wallet, payout_released: Wallet,
  request_expired: Timer, request_lost: XCircle, request_withdrawn: XCircle, declined: XCircle,
  trip_alert: Route, cod_selected: Banknote,
};

export const NotifIcon = ({ kind, className = "w-4 h-4" }) => {
  const Icon = ICONS[kind] || Bell;
  return <Icon className={className}/>;
};

export const notifLink = (n) => n.link || (n.delivery_id ? `/delivery/${n.delivery_id}` : null);
